import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {SlotComponentConfig} from '../../lib/WidgetConfig'
import {DynamicComponent} from './DynamicComponent'
import {DynamicComponentType} from '../../lib/DynamicComponents'

///////////////////////////////////////////////////////////////////////////////

export type DynamicBlockContentProps = {
  component: DynamicComponentType
  children?: SlotComponentConfig[]

  [key: string]: any
}

///////////////////////////////////////////////////////////////////////////////

export const DynamicBlockContent: FC<DynamicBlockContentProps> = observer(
  (props) => {
    const {component, children, ...rest} = props

    return (
      <div className="widget-block-content">
        <DynamicComponent slots={children} {...rest} />
      </div>
    )
  },
)
